import { TAGS } from "../constants";
import { CreatePromoBanner, PromoBanner, UpdatePromoBanner } from "../types";
import { api } from "./api";

export const bannersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // banners
    getPromoBanners: builder.query<
      { data: PromoBanner[]; count: number },
      { status?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: "/api/banners",
        params,
      }),
      providesTags: [TAGS.PROMO_BANNERS],
    }),
    createPromoBanner: builder.mutation<PromoBanner, CreatePromoBanner>({
      query: (body) => ({
        method: "POST",
        url: "/api/banners",
        body,
      }),
      invalidatesTags: [TAGS.PROMO_BANNERS],
    }),
    updateBanner: builder.mutation<
      PromoBanner,
      { id: number; body: UpdatePromoBanner }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `/api/banners/${id}`,
        body,
      }),
      invalidatesTags: [TAGS.PROMO_BANNERS],
    }),
  }),
});

export const {
  useGetPromoBannersQuery,
  useCreatePromoBannerMutation,
  useUpdateBannerMutation,
} = bannersApi;
